<app-map-control-container [position]="position">
  <button class="map-control-btn margin-top" (click)="onChangeZoomPressed(1)"><i class="icon-plus"></i></button>
  <button class="map-control-btn" (click)="onChangeZoomPressed(-1)"><i class="icon-minus"></i></button>
  <ng-content></ng-content>
</app-map-control-container>
